module.exports = __webpack_public_path__ + "static/img/产品界面图_02@2x.21811ef2.png";